<style lang="less">
  @import "./TrackQuery.less";
</style>

<template>
  <div class="track-query">
    <div id="container"></div>
    <div class="track-search" @click="openTrackQueryFn" v-if="!showTrack"><img src="../../../assets/images/map/ic_path_search.png" alt=""></div>
    <div v-if="showListInfo && pathPointDataShow.pathPointData && pathPointDataShow.pathPointData.length>1">
      <!--<div class="track-pause" @click="pauseAndResumeFn('pause')" v-if="actionState==='start' || actionState==='resume'"><img src="../../../assets/images/map/ic_btn_pause.png" alt=""></div>-->
      <!--<div class="track-pause" @click="pauseAndResumeFn('resume')" v-if="actionState==='pause'"><img src="../../../assets/images/map/ic_btn_resume.png" alt=""></div>-->
    </div>
    <div class="track-address" v-if="showListInfo && pathPointDataShow.pathPointData && pathPointDataShow.pathPointData.length>1">
      <p class="track-btn clear">
        <van-icon name="pause-circle-o" size="40" @click="pauseAndResumeFn('pause')"  v-if="actionState==='start' || actionState==='resume'"/>
        <van-icon name="play-circle-o" size="40" @click="pauseAndResumeFn('resume')" v-if="actionState==='pause'"/>
        <span>回放速度</span>
        <van-slider v-model="navgSpeed" :min="1" :max="99" @change="onChangeNavgSpeedFn" class="track-query-shock" v-if="navgSpeed">
          <div slot="button" class="custom-button" >
            {{ navgSpeed }}
          </div>
        </van-slider>
      </p>
      <p><span class="theme-color">起点：</span>{{(pathPointDataShow.startAdr || '未知') + ' (' + pathPointDataShow.startTime + ')'}}</p>
      <p><span class="green-color">终点：</span>{{(pathPointDataShow.endAdr || '未知') + ' (' + pathPointDataShow.endTime + ')'}}</p>
    </div>
    <div class="track-address" v-if="showListInfo && pathPointDataShow.pathPointData && pathPointDataShow.pathPointData.length===1">
      <p><span class="green-color">地点：</span>{{pathPointDataShow.startAdr || '未知'}}</p>
      <p><span class="green-color">时间：</span>{{pathPointDataShow.startTime || '未知'}}</p>
    </div>
    <div class="track-address" v-if="onlyShowAddress">
      <p><span class="green-color">说明：</span>该时间段车辆位置未发生变化</p>
      <p><span class="green-color">地点：</span>{{onlyShowAddress || '未知'}}</p>
    </div>
    <van-popup v-model="showTrack" round closeable position="bottom">
      <div class="popup-title">选择查询时间段</div>
      <div class="popup-con">
        <div>
          <van-cell-group>
            <van-cell title="开始时间" icon="aim" :value="startTime" is-link @click="selectStartTimeFn" />
            <van-cell title="结束时间" icon="aim" :value="endTime" is-link @click="selectEndTimeFn" />
          </van-cell-group>
          <div class="page-btn">
            <van-button type="info" size="large" @click="queryCheckFn">开始查询</van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showPopupStartTime" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="onclosePopupFn"
        @confirm="onSelectStartTimeFn"
      />
    </van-popup>
    <van-popup v-model="showPopupEndTime" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="onclosePopupFn"
        @confirm="onSelectEndTimeFn"
      />
    </van-popup>
    <van-popup v-model="showTrackList" round closeable position="bottom" :style="{ height: + pathPointDataAll.length>9?'80%':'auto' }">
      <div class="popup-title">选择回放时间段</div>
      <div class="popup-con">
        <div class="track-tist">
          <p v-for="(item,index) in pathPointDataAll" :key="item.startTime" :class="pathPointDataShowIndex===index?'active':''"  @click="selectTrackList(index)">{{item.startTime + '——' + item.endTime}}</p>
        </div>
        <div class="popup-btn">
          <van-button type="info" size="large" @click="reQueryFn">重新查询</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import TrackQuery from './TrackQuery.js'
export default {
  ...TrackQuery
}
</script>
